"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.KeyVisual = void 0;

var _react = _interopRequireDefault(require("react"));

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _Section = _interopRequireDefault(require("@jobmatchme/ui/es/components/Section"));

var _ThemeProvider = require("@jobmatchme/ui/es/provider/ThemeProvider");

// TODO: This component can be removed since the key visuals of the page share only the wrapper. This only creates conlicts with the section component -> no row

/**
 * The Header component showing a generic header with a optinal background
 * image or color
 *
 * @param	{string}			backgroundClass	A CSS Module containing the background styling
 * @param	{string}			backgroundColor	A css conform hex/rgb/rgba color code
 * @param {Reacr.Node}	The headers children
 **/
var KeyVisual = function KeyVisual(_ref) {
  var children = _ref.children,
      backgroundClass = _ref.backgroundClass,
      backgroundColor = _ref.backgroundColor,
      _ref$globalThemeVaria = _ref.globalThemeVariant,
      globalThemeVariant = _ref$globalThemeVaria === void 0 ? 'pc' : _ref$globalThemeVaria;
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      position: 'relative'
    }
  }, /*#__PURE__*/_react.default.createElement(_Section.default, {
    noMargin: true,
    noPadding: true,
    backgroundColor: backgroundColor,
    backgroundClass: backgroundClass,
    row: false
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_styleModule.default.wrapper, " ").concat(_styleModule.default[globalThemeVariant])
  }, children)));
};

exports.KeyVisual = KeyVisual;

var _default = /*#__PURE__*/_react.default.memo((0, _ThemeProvider.withThemeVariant)(KeyVisual));

exports.default = _default;